/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line





  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

/* ============================================================
   QUICKBUY SLIDER
   Builds a working horizontal carousel inside the Quick View
   popup. The popup HTML is injected via the Section Rendering
   API, so we use a MutationObserver to wire up the controls
   each time a new gallery shows up.
   ============================================================ */
(function () {
  var SLIDER_SELECTOR = '.popup-quick-view .product-single__media-slider';
  var INIT_FLAG = 'qbSliderReady';

  function initSlider(slider) {
    if (slider.dataset[INIT_FLAG]) return;
    var gallery = slider.closest('.popup-quick-view__gallery');
    if (!gallery) return;
    var slides = slider.querySelectorAll('.product-single__media-slide');
    if (!slides.length) return;
    slider.dataset[INIT_FLAG] = '1';
    if (slides.length < 2) {
      gallery.setAttribute('data-qb-single', '');
      return;
    }
    if (gallery.querySelector('.qb-slider-arrow')) return;

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'qb-slider-arrow qb-slider-arrow--prev';
    prev.setAttribute('aria-label', 'Previous image');
    prev.innerHTML = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M8 2 L4 6 L8 10"/></svg>';

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'qb-slider-arrow qb-slider-arrow--next';
    next.setAttribute('aria-label', 'Next image');
    next.innerHTML = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4 2 L8 6 L4 10"/></svg>';

    var dots = document.createElement('div');
    dots.className = 'qb-slider-dots';
    for (var i = 0; i < slides.length; i++) {
      var d = document.createElement('span');
      d.className = 'qb-slider-dots__dot' + (i === 0 ? ' qb-slider-dots__dot--active' : '');
      dots.appendChild(d);
    }

    gallery.appendChild(prev);
    gallery.appendChild(next);
    gallery.appendChild(dots);

    function currentIdx() {
      var w = slider.clientWidth || 1;
      return Math.max(0, Math.min(slides.length - 1, Math.round(slider.scrollLeft / w)));
    }
    function update() {
      var idx = currentIdx();
      var children = dots.children;
      for (var i = 0; i < children.length; i++) {
        children[i].classList.toggle('qb-slider-dots__dot--active', i === idx);
      }
      prev.disabled = idx <= 0;
      next.disabled = idx >= slides.length - 1;
    }
    function go(delta) {
      var idx = currentIdx() + delta;
      if (idx < 0) idx = 0;
      if (idx > slides.length - 1) idx = slides.length - 1;
      slider.scrollTo({ left: idx * (slider.clientWidth || 1), behavior: 'smooth' });
    }

    prev.addEventListener('click', function (e) { e.preventDefault(); go(-1); });
    next.addEventListener('click', function (e) { e.preventDefault(); go(1); });
    slider.addEventListener('scroll', function () { window.requestAnimationFrame(update); });
    update();
  }

  function scan() {
    document.querySelectorAll(SLIDER_SELECTOR).forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
        scan();
        return;
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();

/* ============================================================
   QUICKBUY: sync size pill highlight on first click
   The theme's popout JS at theme.js:4989-5000 only moves the FIRST
   "--current" class it finds when a size is clicked. The list items
   carry both .select-popout__item--current and .qb-popout__item--current,
   and only the former gets moved — leaving qb-popout__item--current on
   the previously selected item until the second click. This handler
   runs after the theme's listener (bubble phase) and rewrites
   .qb-popout__item--current to follow .select-popout__item--current,
   so the brown highlight tracks the actual variant on the first click.
   ============================================================ */
(function () {
  var ITEM_SELECTOR = '.qb-popout__item';
  var SELECT_CURRENT = 'select-popout__item--current';
  var QB_CURRENT = 'qb-popout__item--current';

  document.addEventListener('click', function (e) {
    var option = e.target.closest(
      '.popup-quick-view .selector-wrapper--qb-popout [data-popout-option]'
    );
    if (!option) return;

    var list = option.closest('.qb-popout__scroll, .select-popout__list__scroll');
    if (!list) return;

    list.querySelectorAll(ITEM_SELECTOR).forEach(function (item) {
      item.classList.toggle(QB_CURRENT, item.classList.contains(SELECT_CURRENT));
    });
  });
})();

/* ============================================================
   QUICKBUY: move title / price / size selector into the foot
   Color swatches stay in __body so the theme's swatch-init JS
   keeps working — only the title, price, and the custom size
   popout (which we built ourselves) are reparented.
   ============================================================ */
(function () {
  var ITEM_SELECTOR = '.popup-quick-view [data-quick-view-item]';
  var DONE_FLAG = 'qbReorganized';

  function reorganize(item) {
    if (item.dataset[DONE_FLAG]) return;
    var footInner = item.querySelector('.popup-quick-view__foot__inner');
    var submitHolder = item.querySelector('.product__submit__holder');
    if (!footInner || !submitHolder) return;

    var title = item.querySelector('.popup-quick-view__title');
    var priceBlock = item.querySelector('.popup-quick-view__body .product__block.product__price-and-badge');
    // The .selector-wrapper--qb-popout is the custom size popout we
    // build for the quickview only. It's safe to move because we own
    // the markup — no theme JS references its DOM position.
    var sizeWrapper = item.querySelector('.popup-quick-view__body .selector-wrapper--qb-popout');

    if (title && title.parentElement !== footInner) {
      footInner.insertBefore(title, submitHolder);
    }
    if (priceBlock && priceBlock.parentElement !== footInner) {
      footInner.insertBefore(priceBlock, submitHolder);
    }
    if (sizeWrapper && sizeWrapper.parentElement !== footInner) {
      footInner.insertBefore(sizeWrapper, submitHolder);
    }

    item.dataset[DONE_FLAG] = '1';
  }

  function scan() {
    document.querySelectorAll(ITEM_SELECTOR).forEach(reorganize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  var qbObserver = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
        scan();
        return;
      }
    }
  });
  qbObserver.observe(document.documentElement, { childList: true, subtree: true });
})();

document.addEventListener('DOMContentLoaded', function() {
  var radios = document.querySelectorAll('.swatch__input');
  radios.forEach(function(radio) {
    radio.addEventListener('change', function() {
      var colorval = document.querySelector('.swatch__input:checked').value;
      showColorImages(colorval);
      document.getElementById('swatchname').innerHTML = colorval;
    });
  });

  if (document.querySelectorAll('.swatch__input').length > 0) {
    var colorval = document.querySelector('.swatch__input:checked').value;
    showColorImages(colorval);
    document.getElementById('swatchname').innerHTML = colorval;
  }
  
});

window.onload = function() {
  if (document.querySelectorAll('.swatch__input:checked').length > 0) {
    var colorval = document.querySelector('.swatch__input:checked').value;
    showColorImages(colorval);
    
  }

// Set "In stock" as the default option in the availability filter
  if (document.querySelectorAll(".collection__filters-list .filter__input#filter-Availability-1").length > 0) {
    
     document.querySelectorAll(".collection__filters-list .filter__input#filter-Availability-1").forEach(function(felement) {
        felement.checked = true;
     });
  }

};

function showColorImages(colorname) {
  var imageallElements = document.querySelectorAll('.imageall');
  imageallElements.forEach(function(element) {
    element.classList.add('hideimage');
    element.classList.remove('is-visible');
    if (element.getAttribute('data-color') === colorname) {
      element.classList.remove('hideimage');
      element.classList.add('is-visible');
    }
  });

  if (window.innerWidth < 1008) {
    /*document.body.addEventListener('touchmove', function(e) {
      setTimeout(function() {
        console.log(2)
        var visibleImage = document.querySelector('.imageall.product-single__media-slide.is-selected.hideimage');
        if (visibleImage) {
          
          console.log(3)
          console.log(document.querySelector('.product-single__thumbnail.imageall.is-visible:first-child').getAttribute('data-id'));
          var divElement = document.querySelector('.imageall.product-single__thumbnail.is-visible:first-child');
          var event = new MouseEvent('click', {
            bubbles: 0
          });
          divElement.dispatchEvent(event);
        }
      }, 100);
    });*/
  }
}


function opennewsletter(){
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', 'Xwz57X']);
}

(function () {
  function delayButtonVisibility() {
    var buttons = document.querySelectorAll('.template-product button.product__popup__link');
    
    // Show all buttons after 1 second with inline styling
    setTimeout(function() {
      buttons.forEach(function(button) {
        button.style.display = 'inline-block';
      });
    }, 2000);
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', delayButtonVisibility);
  } else {
    delayButtonVisibility();
  }
})();
